import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  kanbanList(data) {
    return get(url.kanbanList, data)
  },
  remarkList(data) {
    return post(url.remarkList, data)
  },
  createRmark(data) {
    return post(url.createRmark, data)
  },
  delRmark(data) {
    return get(url.delRmark, data)
  },
  queryRmark(data) {
    return post(url.queryRmark, data)
  }
}